import "core-js/modules/es.string.trim.js";
import React from 'react';
import PropTypes from 'prop-types';
import DelayMouseOver from '../utils/DelayMouseOver';

var MenuToggle = function MenuToggle(_ref) {
  var activeMenu = _ref.activeMenu,
      on = _ref.on,
      setActiveMenu = _ref.setActiveMenu,
      title = _ref.title;
  return on === 'click' ? /*#__PURE__*/React.createElement("div", {
    className: " dropdown-toggle d-flex justify-content-between ".concat(activeMenu === title.toLowerCase() ? 'active' : '').trim(),
    onTouchStart: function onTouchStart() {
      return setActiveMenu(title.toLowerCase());
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu-name"
  }, title), /*#__PURE__*/React.createElement("i", {
    className: "fa fa-angle-down"
  })) : /*#__PURE__*/React.createElement(DelayMouseOver, {
    className: " dropdown-toggle d-flex justify-content-between ".concat(activeMenu === title.toLowerCase() ? 'active main-txt-active' : '').trim(),
    delay: 100,
    onMouseOver: function onMouseOver() {
      return setActiveMenu(title.toLowerCase());
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu-name"
  }, title), /*#__PURE__*/React.createElement("i", {
    className: "fa fa-angle-down"
  }));
};

MenuToggle.propTypes = {
  activeMenu: PropTypes.string,
  on: PropTypes.string,
  setActiveMenu: PropTypes.func,
  title: PropTypes.string
};
export default MenuToggle;